import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'calendar'
AdminRouter.addRoutes([
  {
    name: `company-calendars`,
    path: `/company-calendars`,
    component: () => import('./Calendar.vue'),
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: `${base}`,
  text: $vm => $vm.$t(`${base}.title`),
  header: $vm => $vm.$t(`general.menu_management`),
  route: {
    name: `company-calendars`,
  },
  icon: 'icon-calendar2',
  permission: $vm => {
    return $vm.$account && $vm.$account.company
  },
})

messageGroups.push(base)
